import { Component, OnInit } from '@angular/core';
import { MyMenuService } from '../tool/service/menu.service';
import { SubscriptService } from '../tool/service/header.service';
import { LayoutService } from '../@core/utils';
import { NbSidebarService, NbMenuService,  NbMenuItem } from '@nebular/theme';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { HostListener } from '@angular/core';

//2024.02.20 增加側選單內間距，點選後需要自動收合
@Component({
  selector: 'ngx-main',
  template: `

  <ngx-one-column-layout>
    <nb-menu [items]="info.menu" tag="sys-menu" style="padding-bottom:100px" [autoCollapse]="autoCollapse"></nb-menu>
    <router-outlet></router-outlet> 
    
  </ngx-one-column-layout>
`,
  styleUrls: []
})
export class MainComponent implements OnInit {

  info = {
    menu : []
  }
  menuSub : any

  //2024.02.20 增加側選單點選後需要自動收合
  autoCollapse: boolean = this.isPhone();

  constructor(
    private sidebarService: NbSidebarService,
    private layoutService: LayoutService,
    private ms :MyMenuService,
    private hs: SubscriptService,
    private menuService: NbMenuService,
    private _router: Router,
    private cookieService: CookieService,) { 

    this.menuSub = this.menuService.onItemClick().subscribe((event) => {      
      if (event.tag == "sys-menu") {  
        
        this.hs.AuthChangeSubject.next(event)

        if(window.innerWidth < 750 ||  this.isPhone()){
          console.log('...')
          this.sidebarService.toggle(true, 'menu-sidebar');
        }    

        this.layoutService.changeLayoutSize();
        
         //失效登出
        if(!this.cookieService.get('ORG_Company_ID')){
          this.ms.logout();
        }
      }

      

    });
  }

  ngOnDestroy() {
    if (this.menuSub) {
      this.menuSub.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.ms.getMenu()
    this.info.menu = this.ms.menu    
  }

  //2024.02.20 監聽螢幕尺寸變更
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.autoCollapse = this.isPhone();
    console.log(this.autoCollapse)
  }

    //判斷手機版
    isPhone() {
      let useragent = navigator.userAgent;
      let rules = ['WebView', '(iPhone|iPod|iPad)(?!.*Safari\/)', 'Android.*(wv|\.0\.0\.0)'];
      let regex = new RegExp(`(${rules.join('|')})`, 'ig');
      let ans =  Boolean(useragent.match(regex));
      return ans
    }

}





